<template>
  <div class="registry-box">
    <div class="top-icon">
      <img src="@/assets/logo_gold.png" @click.stop="toHome" />
    </div>
    <div class="user-pannel">
      <div class="re-title">Retrieve Password</div>
      <div class="form-box">
        <el-form
          :model="emailRegistryForm"
          ref="emailRegistryForm"
          :rules="emailRegistryFormRule"
        >
          <el-form-item label="New password" prop="password">
            <el-input
              type="password"
              v-model.trim="emailRegistryForm.password"
              placeholder="Enter an new password"
            ></el-input>
          </el-form-item>
          <el-form-item label="Confirm password" prop="newPassword">
            <el-input
              type="password"
              v-model.trim="emailRegistryForm.newPassword"
              placeholder="Confirm password"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="regist-bt-box">
          <div v-loading="resetLoading" class="regist-bt" @click="submitPwd">
            Submit
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from "../Sys/User.vue";
import { isEmail } from "@/utils/validate";
import { Md5ChangePass } from "@/utils/comm";
import { mapState, mapGetters } from "vuex";
export default {
  components: {},
  computed: {},
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error("Please confirm new password"));
      } else if (value !== this.emailRegistryForm.password) {
        callback(new Error("The passwords entered twice do not match!"));
      } else {
        callback();
      }
    };
    return {
      emailRegistryForm: {
        password: "",
        newPassword: "",
      },
      emailRegistryFormRule: {
        password: [
          {
            required: true,
            message: "Please enter a new password",
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur",
          },
        ],
      },
      resetLoading: false,
    };
  },
  created() {},
  methods: {
    async submitPwd() {
      this.resetLoading = true;
      this.$refs["emailRegistryForm"].validate(async (valid) => {
        if (!valid) {
          return;
        }
        const login_name = this.$route.query.email;
        const verifykey = this.$route.query.verify_key;
        const cts = this.$route.query.cts;

        if (!login_name || !verifykey || !cts) {
          this.$message({
            type: "warning",
            message:
              "Please get the link to retrieve your password from your email",
          });
          return;
        }
        let params = {
          login_name,
          verifykey,
          cts,
          newPassword: Md5ChangePass(this.emailRegistryForm.newPassword),
        };

        const { status, message } = await this.$api.userApi.resetPassword(
          params
        );
        this.$message({
          type: status === "0" ? "success" : "error",
          message: message,
        });
        this.resetLoading = false;
        if (status === "0") {
          this.$router.push("/");
        }
      });
      this.resetLoading = false;
    },
    toHome() {
      this.$router.push("home");
    },
  },
};
</script>

<style lang="scss" scoped>
.registry-box {
  min-height: 100vh;
  background: #fce9d1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  .top-icon {
    text-align: center;
    padding: 28px;
    cursor: pointer;
    img {
      width: 113px;
      height: 40px;
    }
  }
  .user-pannel {
    // width: vw(600);
    width: 100%;
    // height: vw(625);
    background: #fff;
    // margin-top: vw(60);
    text-align: center;
    border-radius: 8px;
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    .form-box {
      // width: vw(360);
      width: 100%;
      // margin: vh(30) 0 vh(10) 0;
      margin-top: 16px;
    }
    .el-form {
      margin-top: 16px;
      width: 100%;
    }
    .el-form-item {
      margin-bottom: 32px;
      .forgot-password {
        cursor: pointer;
        float: right;
        font-size: 14px;
        font-weight: 600;
        color: #f48c06;
        line-height: 20px;
      }
    }
    /deep/ .el-input__inner {
      // width: vw(360);
      width: 100%;
    }
    /deep/ .el-form-item.is-error .el-input__inner {
      border-color: #f42506 !important;
    }
    /deep/ .el-form > .el-form-item > .el-form-item__label {
      //label样式
      font-size: 14px;
      font-weight: 600;
      color: #201002;
      line-height: 20px;
    }
    /deep/ .el-form > .el-form-item > .el-form-item__content {
      line-height: 100%;
      .el-input {
        margin-top: 8px;
        .el-input__inner {
          height: 48px;
          border-radius: 8px;
          border: 1px solid rgba(32, 16, 2, 0.32);
        }
      }
      .el-select {
        width: 100%;
      }
      .el-form-item__error {
        font-size: 14px;
        // font-weight: 600;
        color: #f42506;
      }
    }
    .re-title {
      font-weight: 600;
      color: #201002;
      line-height: 24px;
      font-size: 20px;
      font-family: "PingFangSC-Semibold", "PingFang SC";
    }
    .regist-bt-box {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .regist-bt {
      width: 100%;
      height: 48px;
      font-size: 14px;
      font-weight: 600;
      border-radius: 8px;
      cursor: pointer;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f48c06;
      margin-top: 16px;
      &:hover {
        opacity: 0.54;
      }
    }
    .re-google {
      background: #5d99fb;
      margin-top: 32px;
    }
    .re-facebook {
      background: #3b5998;
    }
    .re-email {
      background: #fa6484;
    }
    .re-create {
      background: #f48c06;
      margin-top: 56px;
    }
  }
}
</style>
